module.exports = __webpack_public_path__ + "static/media/6.a00d57c0.jpg";